// TODO: Replace mock functions
// import { getScripts, includes } from './utils';
export const getScripts = () => {
  const headScripts = [...document.getElementsByTagName('head')[0].children].filter(
    (x) => x.tagName === 'SCRIPT'
  );
  const bodyScripts = [...document.getElementsByTagName('body')[0].children].filter(
    (x) => x.tagName === 'SCRIPT'
  );

  return [...headScripts, ...bodyScripts];
};

export const includes = (server, file) => (s) =>
  s.src.match(new RegExp(`${server}\\/[0-9]+/${file}.js`, 'g'));

export const isScriptNotAttached = (server, file) =>
  getScripts().filter(includes(server, file)).length === 0;
